import React, { useMemo } from "react";
import { useIngresos } from "../../Context/IngresosContext";
import Grid from "@material-ui/core/Grid";
import style from "../../assets/jss/disal-main/Layouts/Ingresos";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Modal from "../../Component/Modal/ModalIngres";
import Pagination from "../../Component/Pagination/PaginationPatio";
import { DatePicker, message } from "antd";
import "antd/dist/antd.css";
import moment from "moment";

const useStyles = makeStyles(style);
const IngresosContent = () => {
  const classes = useStyles();
  const miningSites = JSON.parse(localStorage.getItem('miningSites'));
  const {
    miningSite,
    totalPages,
    ingresos,
    warehouse,
    warehouses,
    fromDay,
    toDay,
    selected,
    setPage,
    setSelected,
    setMiningSite,
    setWarehouse,
    setFromDay,
    setToDay
  } = useIngresos();

  const title = useMemo(() => {
    if(miningSite === 0 && warehouse === 0){
      return "Mostrando ingresos de residuos para todas las plantas";
    } else if(miningSite !== 0 && warehouse === 0){
      const miningSiteName = miningSites.find((res) => res.id === miningSite).name;
      return "Mostrando ingresos de residuos para todos los patios de " + miningSiteName;
    } else if(miningSite !== 0 && warehouse !== 0){
      const miningSiteName = miningSites.find((res) => res.id === miningSite).name;
      const warehouseName = warehouses.find((res) => res.id === warehouse).name;
      return "Mostrando ingresos de residuos para " + warehouseName + " de " + miningSiteName;
    }
    return "";
  }, [miningSite, warehouse, miningSites, warehouses]);

  const validateFromDay = (value) => {
    const newFromDay = moment(value);

    if(newFromDay.isAfter(toDay)){
      message.error(
        `La fecha debe ser igual o menor a la fecha ${toDay.format("DD/MM/YYYY")}`,
        1.5
      );
      setFromDay(toDay);
    }else{
      setFromDay(newFromDay);
    }
  };

  const validateToDay = (value) => {
    const newToDay = moment(value);

    if(newToDay.isBefore(fromDay)){
      message.error(
        `La fecha debe ser igual o mayor a la fecha ${fromDay.format("DD/MM/YYYY")}`,
        1.5
      );
      setToDay(fromDay);
    }else{
      setToDay(newToDay);
    }
  };

  return (
    <Grid container className={classes.ingresos}>
      <h4>Revisa los ingresos de residuo a Patio Temporal</h4>
      <Grid item sm={12} gap={2}>
        <Grid container>
          <Grid item style={{ marginBottom: "25px" }}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={miningSite}
                onChange={(e) => {
                  setMiningSite(e.target.value);
                }}
              >
                <MenuItem value={0}>Todos las plantas</MenuItem>
                {miningSites.map((res, key) => {
                  return (
                    <MenuItem key={key} value={res.id}>
                      {res.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ marginBottom: "25px" }}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={warehouse}
                disabled={miningSite === 0}
                onChange={(e) => {
                  setWarehouse(e.target.value);
                }}
              >
                <MenuItem value={0}>Todos los Patios</MenuItem>
                {warehouses.filter((yard) => yard.mining_site_id === miningSite).map((res, key) => {
                  return (
                    <MenuItem key={key} value={res.id}>
                      {res.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ marginBottom: "25px" }}>
            <label style={{ margin: "0 10px" }}>
                <strong>Del: </strong>
            </label>
            <DatePicker
              value={fromDay}
              onChange={validateFromDay}
              size="large"
              className="header-select"
              placeholder="Desde"
              format="DD/MM/YYYY"
              maxDate={toDay}
            />
          </Grid>
          <Grid item style={{ marginBottom: "25px" }}>
            <label style={{ margin: "0 10px" }}>
                <strong>Al: </strong>
            </label>
            <DatePicker
              value={toDay}
              onChange={validateToDay}
              size="large"
              className="header-select"
              placeholder="Desde"
              format="DD/MM/YYYY"
              minDate={fromDay}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item sm={12} className={classes.mainTable}>
        <h3
          style={{
            color: "#0D0D0D",
            fontFamily: "Roboto",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "20px",
            textAlign: "left",
          }}
        >
          {title}
        </h3>
        <TableContainer className={classes.contentTable}>
          <Table
            className={classes.tableGeneral}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow className={classes.cellOperativo}>
                <TableCell>Fecha</TableCell>
                <TableCell>Hora</TableCell>
                <TableCell>Planta</TableCell>
                <TableCell>Patio</TableCell>
                <TableCell>Vehículo</TableCell>
                <TableCell>Peso Total(Ton.)</TableCell>
                <TableCell>Detalle</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ingresos.map((item, index) =>
                <TableRow key={"row-data-" + index}>
                  <TableCell>{item.inputDate !== null ? item.inputDate : "-"}</TableCell>
                  <TableCell>{item.inputTime !== null ? item.inputTime : "-"}</TableCell>
                  <TableCell>{item.miningSiteName !== null ? item.miningSiteName : "-"}</TableCell>
                  <TableCell>{item.warehouseName !== null ? item.warehouseName : "-"}</TableCell>
                  <TableCell>{item.vehiclePlateNumber !== null ? item.vehiclePlateNumber : "-"}</TableCell>
                  <TableCell>{item.totalKG !== null ? (parseFloat(item.totalKG) / 1000).toFixed(2) : "-"}</TableCell>
                  <TableCell>
                    <button
                      type="button"
                      className="btn-ingresos"
                      id={index}
                      data-id={item.inputId}
                      onClick={() => setSelected(item)}
                    >
                      Ver detalle
                    </button>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Pagination
        totalRecords={totalPages}
        pageLimit={15}
        initialPage={1}
        pageToShow={4}
        onChangePage={({ page }) => setPage(page)}
      />
      {selected && (
        <Modal
          onClose={() => setSelected(null)}
          data={selected}
        />
      )}
    </Grid>
  );
};

export default IngresosContent;
